import { defineComponent, ref, onMounted, computed } from '@vue/composition-api';
import __vue_component__$1 from '../SdsButtonIcon/SdsButtonIcon.vue.js';
import __vue_component__ from '../SdsIcon/SdsIcon.vue.js';

var idGenerator = 0;
var script = defineComponent({
    name: 'SdsBaseInput',
    props: {
        name: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            required: false,
            default: undefined,
        },
        label: {
            type: String,
            required: true,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        isReadOnly: {
            type: Boolean,
            required: false,
            default: false,
        },
        isClearable: {
            type: Boolean,
            required: false,
            default: false,
        },
        inputmode: {
            type: String,
            required: false,
            default: 'text',
        },
        autocomplete: {
            type: String,
            required: false,
            default: undefined,
        },
        autofocus: {
            type: Boolean,
            required: false,
            default: false,
        },
        message: {
            type: String,
            required: false,
            default: undefined,
        },
        status: {
            type: String,
            required: false,
            default: undefined,
        },
        alignment: {
            type: String,
            required: false,
            default: 'left',
        },
        size: {
            type: String,
            required: false,
            default: 'md',
        },
        placeholder: {
            type: String,
            required: false,
            default: undefined,
        },
        dataTestId: {
            type: String,
            required: false,
            default: undefined,
        },
    },
    model: {
        prop: 'value',
        event: 'update:value',
    },
    emits: [
        'update:value',
        'beforeinput',
        'focus',
        'blur',
        'click',
        'keydown',
        'keypress',
        'keyup',
        // Exposed if we need analytics or some reaction to this
        'cleared',
    ],
    setup: function (props, _a) {
        var emit = _a.emit;
        var isFocused = ref(false);
        var inputElementRef = ref();
        // eslint-disable-next-line no-plusplus
        var idSuffix = idGenerator++;
        function setIsFocused(value, event) {
            if (props.isReadOnly || props.isDisabled) {
                return;
            }
            isFocused.value = value;
            if (value) {
                emit('focus', event);
            }
            else {
                emit('blur', event);
            }
        }
        function clearInput() {
            emit('update:value', undefined);
            emit('cleared');
        }
        function handleContextMenu(event) {
            // On OS X, clicking on the input while focused will just open the context menu, which we do not want
            if (isFocused.value && event.pointerType === 'mouse') {
                event.preventDefault();
            }
        }
        onMounted(function () {
            var _a;
            if (props.autofocus) {
                (_a = inputElementRef.value) === null || _a === void 0 ? void 0 : _a.focus();
            }
        });
        return {
            inputId: computed(function () { return "".concat(props.name, "-").concat(idSuffix); }),
            inputElementRef: inputElementRef,
            isFocused: isFocused,
            setIsFocused: setIsFocused,
            clearInput: clearInput,
            handleContextMenu: handleContextMenu,
        };
    },
    components: {
        SdsIcon: __vue_component__,
        SdsButtonIcon: __vue_component__$1,
    },
});

export default script;
